import type {
  InkingEditSubMode,
  InkingFeatureFlags,
  InkingTool,
  DrawingPressureMode,
} from "./storeTypes.ts";

export const DEFAULT_INKING_FEATURES: InkingFeatureFlags = {
  silhouette: true,
  crease: true,
  screenEdges: true,
};

/**
 * Defaults for the editable inking canvas sub-mode. These tune toward
 * fine-line inking rather than broad sketching: hairline radius, full hardness, full
 * opacity. Pressure still modulates stroke feel for stylus input, but mouse
 * strokes land opaque instead of half-transparent (see InkingEditLayer's
 * pressure fallback).
 */
export const DEFAULT_INKING_CANVAS_SETTINGS = {
  editSubMode: "view" as InkingEditSubMode,
  tool: "pen" as InkingTool,
  size: 1.5,
  opacity: 1.0,
  hardness: 1.0,
  color: "#111111",
  pressureMode: "opacity" as DrawingPressureMode,
  showReference: false,
  pan: [0, 0] as [number, number],
  zoom: 1,
  rotation: 0,
} as const;

export const DEFAULT_INKING_SETTINGS = {
  thickness: 2.5,
  thicknessMin: 1.0,
  shadowResponse: 0.75,
  shadowExposure: 0.5,
  opacity: 1.0,
  lineWidthVariation: 0.5,
  detail: 0.5,
  hatchingDirection: 45,
  hatchingExposure: 0.5,
  hatchingDensity: 0.5,
  hatchingJitter: 0,
  distanceNear: 2.0,
  distanceFar: 30.0,
} as const;

export const DEFAULT_INKING_MODE_SETTINGS = {
  features: DEFAULT_INKING_FEATURES,
  creaseAngle: 30,
  taperStrength: 0.4,
  simplificationTolerance: 1.5,
  cornerAngle: 60,
} as const;
